<template>
  <div class="home">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="1"></menuBox>
      <div class="banner-text">
        <div class="title">Kreativitas tanpa batas, <img src="../assets/swiper-1-icon.png" alt=""> <br> komunikasi tanpa batas</div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI, menyediakan layanan periklanan dan perencanaan media yang komprehensif
        </div>
      </div>
    </div>
    <div class="text-box">
      <div class="title">
        Rancang solusi yang lebih baik untuk Anda
      </div>
      <div class="text">
        PT LAYAR CERITA IMAJINASI menyediakan rangkaian lengkap solusi periklanan mulai dari desain kreatif hingga perencanaan dan pembelian media, yang mencakup berbagai saluran media untuk memastikan merek Anda tersebar paling luas dan efektif.
      </div>
    </div>
    <div class="solutions-box">
      <div class="title">
        Layanan kami
      </div>
      <div class="banner-list">
        <div class="item">
          <img src="../assets/business-1.png" alt="" />
          <div class="title">
            desain kreatif
          </div>
          <div class="text">
            Memberikan ide periklanan yang unik dan menghasilkan materi iklan berkualitas tinggi.
          </div>
        </div>
        <div class="item">
          <img src="../assets/business-2.png" alt="" />
          <div class="title">
            perencanaan media
          </div>
          <div class="text">
            Kembangkan strategi media yang tepat untuk mengoptimalkan efek iklan.
          </div>
        </div>
        <div class="item">
          <img src="../assets/business-3.png" alt="" />
          <div class="title">
            pembuatan iklan
          </div>
          <div class="text">
            Meliputi produksi dan penempatan iklan di berbagai platform seperti surat kabar, televisi, dan Internet.
          </div>
        </div>
      </div>
    </div>
    <div class="mission-box">
      <img src="../assets/mession.png" alt="" />
      <div class="content">
        <div class="title">
          Prestasi Kita
        </div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI telah mencapai prestasi luar biasa di bidang kreativitas periklanan dan perencanaan media, dan telah berhasil melaksanakan sejumlah proyek periklanan berskala besar, yang mencakup berbagai platform media besar. Pendekatan inovatif dan pelaksanaan yang efisien telah menempatkan kami di garis depan industri dan membuat kami mendapatkan kepercayaan dan pujian dari banyak klien.
        </div>
        <div class="list">
          <p><img src="../assets/right-icon.png" alt="">Salah satu penyedia layanan paling populer</p>
          <p><img src="../assets/right-icon.png" alt="">Platform Kreatif Terbaik Tahun Ini</p>
          <p><img src="../assets/right-icon.png" alt="">Penghargaan Desain Industri Baru</p>

        </div>
      </div>

    </div>
    <div class="happy-box">
      <div class="content">
        <div class="title">
          Sangat populer di kalangan pelanggan
        </div>
        <div class="text">
          PT LAYAR CERITA IMAJINASI telah mendapatkan pujian luas dari pelanggan atas layanan terbaik dan solusi periklanan inovatifnya. Kami berkomitmen untuk menyediakan strategi khusus kepada pelanggan yang paling sesuai dengan positioning merek dan kebutuhan pasar mereka untuk memastikan keberhasilan setiap proyek.
        </div>
      </div>
      <div class="number-list">
        <img src="../assets/happy-icon.png" alt="">
        <div class="item">
          <h4>
            100+
          </h4>
          <p>professional</p>
        </div>
        <div class="item">
          <h4>
            1000+
          </h4>
          <p>client</p>
        </div>
        <div class="item">
          <h4>
            96%
          </h4>
          <p>satisfy</p>
        </div>
        <div class="item">
          <h4>
            10+
          </h4>
          <p>Outstanding team</p>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";

  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {},
  };
</script>

<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-1.png);
    height: 750px;
    background-size: 100% 100%;

    .banner-text {
      text-align: left;
      width: 600px;
      margin-left: 360px;
      margin-top: 130px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: 800;
        font-size: 56px;
        color: #333333;

        img {
          vertical-align: middle;
          width: 63px;
        }
      }

      .subtitle {
        font-size: 26px;
        font-weight: 500;
        color: #fff;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }

  .text-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 100px 360px;
    background: #FEFBF6;
    .title {
      width: 517px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 50px;
      color: #252B42;
    }

    .text {
      width: 543px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 20px;
      color: #737373;
    }
  }

  .solutions-box {
    padding: 0 360px;
    padding-bottom: 90px;
    background: #FEFBF6;
    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      color: #252B42;
      text-align: center;
    }

    .banner-list {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      margin-top: 100px;

      .item {

        img {
          width: 360px;
          height: 190px;
        }

        .title {
          font-family: Roboto, Roboto;
          font-weight: bold;
          font-size: 24px;
          width: 340px;
          color: #333333;
          padding-top: 25px;
          text-align: left;
          background-color: #fff;padding-left: 20px;
        }

        .text {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 18px;
          padding: 0 20px;
          color: #333333;
          width: 320px;
          padding-top: 10px;
          padding-bottom: 20px;
          border-radius: 0 0 20px 20px;
          text-align: left;
          background-color: #fff;
        }
      }
    }
  }


  .mission-box {
    padding: 50px 360px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #FCDB67;

    .content {
      width: 630px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 46px;
        color: #252B42;
        margin-bottom: 30px;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
      }

      .list {
        margin-top: 20px;

        p {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 20px;
          color: #37393F;
          margin-bottom: 10px;
        }

        img {
          width: 27px;
          height: 27px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    img {
      width: 450px;
      height: 470px;
    }
  }

  .happy-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 100px 360px;
    background-color: #FEFBF6;
    .content {
      width: 580px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 52px;
        color: #252B42;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        margin-top: 30px;
      }
    }

    .number-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      width: 520px;
      img{
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 191px;
      }
      .item:nth-child(2){
        margin-top: 80px;
        margin-bottom: -50px;
      }
      .item:nth-child(3){
        margin-bottom: -50px;
      }
      .item:nth-child(4){
        margin-top: 80px;
      }
      .item {
        width: 248px;
        height: 153px;
        background: #FFFFFF;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        border-radius: 20px 20px 20px 20px;
        text-align: center;
        z-index: 10;
        h4 {
          font-family: Roboto, Roboto;
          font-weight: bold;
          font-size: 52px;
          color: #252B42;
          margin-top: 20px;
        }

        p {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 18px;
          color: #7A7A7A;
        }
      }
    }
  }
</style>